// 默认 页面 加载完成后会主动 window.scrollTo(0, 0) 配置一些不需要处理的url
const NOT_SCROLL_TO_LIST = [
  '/auto/library/', // 车型库
]

const isScroll = (url: string) => {
  if (!url) {
    return true
  }
  const len = NOT_SCROLL_TO_LIST.length
  for (let i = 0; i < len; i++) {
    if (url?.indexOf(NOT_SCROLL_TO_LIST[i]) > -1) {
      return false
    }
  }
  return true
}

export default isScroll
